import { FETCH_CUSTOMER, FETCH_CUSTOMER_BY_ID } from '../types';

export default (state = { isLoading: true, customer: [] }, action) => {
  switch (action.type) {
    case 'START_LOADING':
      return { ...state, isLoading: true };
    case 'END_LOADING':
      return { ...state, isLoading: false };

    case FETCH_CUSTOMER:
      return action.payload;
    case FETCH_CUSTOMER_BY_ID:
      return action.payload;

    default:
      return state;
  }
};
